<template>
  <div id="app">
    <media-selector />
    <IconSelector />
    <library-selector />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MediaSelector from 'bh-mod/components/file/MediaSelector'
import IconSelector from 'bh-mod/components/file/IconSelector'
import LibrarySelector from 'bh-mod/components/file/LibrarySelector'
export default {
  name: 'app',
  components: { MediaSelector,LibrarySelector,IconSelector },
  computed: {
    ...mapGetters(['user'])
  },
  watch: {
    '$route'(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
}
</script>
<style>
  #app{
    min-height: 100vh;
  }
</style>
